import { useOktaAuth } from "@okta/okta-react";
import axios from "axios";

import { useQuery } from "@tanstack/react-query";

export function useFetchAdminAdditionalRxDetails(parameters) {
  const { oktaAuth } = useOktaAuth();

  const dataKey = "useFetchAdminAdditionalRxDetailsResultKey";

  async function GetApiResult() {
    //alert("GetAdminRxDetailsApiResult");
    const accessToken = oktaAuth.getAccessToken();

    //console.log(parameters);

    var result = await axios
      .get("api/AdminRxLookup/GetAdditionalDetailsResult", {
        params: parameters,
        headers: { Authorization: `Bearer ${accessToken}` },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw new Error(error);
      });

    return result;
  }

  return useQuery({
    queryKey: [dataKey, parameters],
    queryFn: async () => await GetApiResult(),
  });
}
